import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "../data.service";
import { FolderComponent } from "../folder/folder.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastService } from "ng-uikit-pro-standard";
import { FormBuilder } from "@angular/forms";
import { AppConfig } from "src/app/config";
import { NewfolderComponent } from "../folder/newfolder/newfolder.component";
@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent implements OnInit {
  label: string;
  name: string;
  showFolderComponent: boolean = true;
  showReportsComponent: boolean = true;

  @Output() folderPropertiesChanged: EventEmitter<any> =
    new EventEmitter<any>();

  constructor(
    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    // if (this.showFolderComponent) {
    //   this.router.navigateByUrl("home/folder/new");
    // }
  }

  folder() {
    this.router.navigateByUrl("home/folder/new");
  }
  newReport() {
    this.router.navigateByUrl("home/report/new");
  }

  updateFolderProperties(properties: any): void {
    this.label = properties.label;
    this.name = properties.name;

    this.folderPropertiesChanged.emit(properties);
  }

  newfolders() {
    const dialogRef = this.dialog.open(NewfolderComponent, {
      data: {
        sectionProperties: {
          label: this.label,
          name: this.name,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The section dialog was closed");
      if (result) {
        this.updateFolderProperties(result);
        console.log("updateSectionProperties", result);
      }
    });
  }
}
